'use client';

import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';

const useAppEventEmitter = () => {
	const eventEmitter = useVelocityStore((s) => s.appEventEmitter);

	return eventEmitter;
};

export default useAppEventEmitter;
